import React, { useState, useEffect } from "react";
import AuthNavComponent from "../module/auth/AuthNav";
import JobItemCard from "./component/JobItemCard";
import { Filter } from "./component/Sidebar/Filter";
import { Pageination } from "sr/helpers/ui-components/Pageination";
import Footer from "../module/Footer";
import { getJobs } from "sr/utils/api/cleaner/jobs/getJobs";
import ContentWithLoader from "sr/layout/common/ContentLoader";
import { JobLoaderCard } from "./component/JobLoaderCard";
import Job from "../component/types/Job";
import { Filter as DrowpDownFilter } from "../company/work-order/component/Filter";
import { TermsAgreePopup } from "../module/auth/TermsAgreePopup";
import { getKycDetails } from "sr/utils/api/cleaner/kyc/getKycDetails";
import { WarningRed } from "sr/helpers/ui-components/company/WarningRed";
import { Link } from "react-router-dom";
import { useAuth } from "../module/auth";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getAccessToken } from "sr/helpers/functions/setAccessTokenMe";
export default function JobList() {
  const jobcount = 13;
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [jobs, setJobs] = useState<Job[]>([]);
  const [totalPage, settotalPage] = useState<number>(0);
  const [loader, setLoader] = useState(false);
  const [filters, setFilters] = useState<any>({});
  const [sortBy, setSortBy] = useState("Date");
  const [trackClick, setTrackClick] = useState(1);
  const [showModel, setShowModel] = useState(false);
  const [cleanerId, setCleanerId] = useState<string>("");
  const [kycCompleted, setKycCompleted] = useState(true);
  const { isAuthenticate, accessToken } = useAuth();
  const [region, setRegion] = useState();
  const HandleFilterData = (data) => {
    setFilters(data);
  };

  const fetchData = async () => {
    const filtersnew = JSON.parse(JSON.stringify(filters));
    setLoader(true);
    const queryParams = new URLSearchParams();
    if (page) queryParams.append("page", page.toString());
    if (limit) queryParams.append("limit", limit.toString());
    if (sortBy === "High to Low") {
      queryParams.append("sortbyrate", "desc");
    }
    if (sortBy === "Low to High") {
      queryParams.append("sortbyrate", "asc");
    }
    if (filtersnew?.business_type) {
      let businessType = filtersnew.business_type;
      if (businessType?.length === 1) {
        businessType += ",";
      }

      if (businessType?.length > 0)
        queryParams.append("business_type", businessType);
    }
    if (filtersnew?.address) {
      if (filtersnew?.address !== "") {
        queryParams.append("address", filtersnew["address"]);
        delete filtersnew?.address;
      }
    }
    const filter = [];
    const first = { status: { $in: ["open"] } };
    filter.push(first);
    if (filtersnew?.rateRange?.minRange && filtersnew?.rateRange?.maxRange) {
      const raterange = {
        $or: [
          {
            exact_amount: {
              $gte: filtersnew?.rateRange?.minRange,
              $lte: filtersnew?.rateRange?.maxRange,
            },
          }, // Check exact_amount within range
          {
            $and: [
              // Check min_amount & max_amount overlap
              { min_amount: { $gte: filtersnew?.rateRange?.minRange } },
              { max_amount: { $lte: filtersnew?.rateRange?.maxRange } },
            ],
          },
          {
            $and: [
              // Check range.min & range.max overlap
              { "range.min": { $gte: filtersnew?.rateRange?.minRange } },
              { "range.max": { $lte: filtersnew?.rateRange?.maxRange } },
            ],
          },
        ],
      };
      filter.push(raterange);
    }
    Object.keys(filtersnew)?.forEach((item) => {
      if (item === "business_type") {
        delete filtersnew[item];
      }
      if (item === "rateRange") {
        delete filtersnew[item];
      }

      if (
        item &&
        filtersnew[item] &&
        (filtersnew[item]?.length > 0 ||
          Object.keys(filtersnew[item]).length > 0)
      ) {
        const condition1 = {};
        const condition2 = {};

        if (item === "createdAt") {
          Object.keys(filtersnew[item]).forEach((key) => {
            if (key && filtersnew[item][key]) {
              if (key === "from") {
                condition1[item] = { $gte: filtersnew[item][key] };
              }

              if (key === "to") {
                condition2[item] = { $lte: filtersnew[item][key] };
              }
            }
          });
        } else {
          if (item !== "payType") {
            condition1[item] = { $in: filtersnew[item] };
          }
        }

        filter.push(condition1);
        filter.push(condition2);
      }
    });
    let newfilter;
    if (filter?.length > 0) {
      if (filter?.length === 1) {
        newfilter = filter[0];
      } else {
        newfilter = { $and: filter };
      }
    }
    if (newfilter) queryParams.append("filter", JSON.stringify(newfilter));
    if (Object.keys(filtersnew).includes("payType")) {
      queryParams.append("rate", filtersnew?.payType);
    }

    try {
      const result: any = await getJobs(`${queryParams}`);
      if (result?.success === true) {
        setJobs(result?.data);
        settotalPage(Math.ceil(result?.pagination.total / limit));
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const handlePageChange = (value) => {
    if (value > totalPage || value < 1) {
      return;
    }
    setPage(value);
  };
  const AgreementHandle = async () => {};

  const fetchKycDetails = async (userId) => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("user_id", userId);
      const res = await getKycDetails(queryParams);

      if (res?.success === true) {
        if (res?.data?.status === "completed") {
          setKycCompleted(true);
        } else {
          setKycCompleted(false);
        }
      }
    } catch (e) {
      setKycCompleted(false);
    }
  };

  useEffect(() => {
    const getDetails = async () => {
      const details = await getUserDetails();
      console.log("details?.user_id", details?.user_id);

      setCleanerId(details?.user_id);
      if (details?.user_id) {
        //   await fetchKycDetails(cleanerId);
        await fetchData();
      }
    };
    getDetails();
  }, []);
  useEffect(() => {
    fetchData();
  }, [page, limit, filters, sortBy, region]);
  useEffect(() => {
    console.log("accessToken", accessToken);
    setTimeout(() => {
      fetchData();
    }, 2000);
  }, [accessToken]);

  return (
    <div>
      <AuthNavComponent
        setRegion={setRegion}
        isLoggedin={true}
      ></AuthNavComponent>
      <div className="lg:container mx-auto lg:max-w-6xl lg:mt-10 mt-10 px-4 lg:px-0 relative">
        {/* Harendra open next */}
        {/* {isAuthenticate && !kycCompleted && <div>
                <WarningRed paragraph={"Please Complete your KYC for Wallet Withdrawals"} link={<Link to="/cleaner/wallet/KYC">Click Here </Link>}></WarningRed>
                </div>} */}
        <div className="flex justify-end">
          <DrowpDownFilter
            trackClick={trackClick}
            name={`Sort by: ${sortBy}`}
            childrenClass=""
            border="border border-neural-200"
          >
            <p
              onClick={() => {
                setSortBy("High to Low");
                setTrackClick((page) => page + 1);
              }}
              className="py-2 px-3 hover:bg-gray-50 cursor-pointer"
            >
              High to Low
            </p>
            <p
              onClick={() => {
                setSortBy("Low to High");
                setTrackClick((page) => page + 1);
              }}
              className="py-2 px-3 hover:bg-gray-50 cursor-pointer"
            >
              Low to High
            </p>
            <p
              onClick={() => {
                setSortBy("Date");
                setTrackClick((page) => page + 1);
              }}
              className="py-2 px-3 hover:bg-gray-50 cursor-pointer"
            >
              Date
            </p>
          </DrowpDownFilter>
        </div>
        <div className="grid lg:grid-cols-4 grid-cols-1 lg:gap-4 gap-0 pt-4">
          <div className="col-span-1">
            <Filter HandleFilterData={HandleFilterData} />
          </div>
          <ContentWithLoader
            loading={loader}
            content={<JobLoaderCard></JobLoaderCard>}
          >
            <div className="col-span-3">
              {jobs?.map((datI, index) => {
                return (
                  <JobItemCard
                    key={index}
                    jobs={datI}
                    link={`/job-detail/${datI.id}`}
                  ></JobItemCard>
                );
              })}
              <Pageination
                page={page}
                totalpage={totalPage}
                limit={limit}
                onPageChange={handlePageChange}
              />
            </div>
          </ContentWithLoader>

          <TermsAgreePopup></TermsAgreePopup>
        </div>
      </div>
      <Footer />
    </div>
  );
}
